// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3ezN4","additionalInfo":"AgreementModal_additionalInfo__1r3ch"};